import moment from 'moment';
import { DATE_FROM, DATE_TO } from 'domains/order/Order.types';

export const handleRangeFilterChange = <TField extends string>(
  dateStrings: [string, string],
  updateFn: (key: TField, value: string) => void,
): void => {
  const [startDate, endDate] = dateStrings;

  if (startDate && endDate) {
    updateFn(DATE_FROM as TField, moment(startDate).startOf('day').toISOString());
    updateFn(DATE_TO as TField, moment(endDate).endOf('day').toISOString());
  } else {
    updateFn(DATE_FROM as TField, '');
    updateFn(DATE_TO as TField, '');
  }
};
